"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedList = void 0;
var Utilities_1 = require("../../Utilities");
var GroupedList_styles_1 = require("./GroupedList.styles");
var GroupedList_base_1 = require("./GroupedList.base");
exports.GroupedList = Utilities_1.styled(GroupedList_base_1.GroupedListBase, GroupedList_styles_1.getStyles, undefined, {
    scope: 'GroupedList',
});
//# sourceMappingURL=GroupedList.js.map